import { render, staticRenderFns } from "./producto2.vue?vue&type=template&id=2db1e700&scoped=true&"
import script from "./producto2.vue?vue&type=script&lang=js&"
export * from "./producto2.vue?vue&type=script&lang=js&"
import style0 from "./producto2.vue?vue&type=style&index=0&id=2db1e700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1e700",
  null
  
)

export default component.exports